exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".imgToSend[data-v-dc79ca00]{display:none}span.singleTag[data-v-dc79ca00]{padding:5px 15px;display:inline-block;margin-left:5px;margin-bottom:5px;border-radius:50px;float:left}.v-card__text.popup-wrapper[data-v-dc79ca00]{max-height:80vh;overflow:scroll}.v-card__subtitle[data-v-dc79ca00]{padding:0}.v-dialog>.v-card>.v-card__subtitle[data-v-dc79ca00],.v-dialog>.v-card>.v-card__text[data-v-dc79ca00]{padding:1em}", ""]);

// exports
